const linkPattern = /\b((https?):\/\/[^\s]+)/i;

export default linkPattern;